import { request } from "services/api/util";

class PublicHolidaysService {
  getHeaders() {
    return {
      "Accept-Language": "th",
    };
  }

  async getListPublicHolidays(params) {
    return request({
      method: "get",
      url: "admin/publicHolidays",
      params,
      headers: this.getHeaders(),
    });
  }

  async deletePublicHolidays(id) {
    return request({
      method: "delete",
      url: `admin/publicHolidays/${id}`,
      headers: this.getHeaders(),
    });
  }

  async createPublicHolidays(body) {
    return request({
      method: "post",
      url: "admin/publicHolidays",
      data: body,
      headers: this.getHeaders(),
    });
  }

  async importFromS3Key(key) {
    return request({
      method: "post",
      url: "admin/publicHolidays/import",
      data: { key },
      headers: this.getHeaders(),
    });
  }
}

export default new PublicHolidaysService();
